export default __webpack_public_path__ + "static/media/ic_percentage_campaign.ba6878d6.svg";